import schema from "./schema.js";
import { Box, Typography } from "@mui/material";

import Datumizo from "Components/LabIZO/Datumizo/Datumizo";
import { VStack } from "Components/LabIZO/Stackizo";
import { ColorX, store } from "static";
import _ from "lodash";
import { DATA_LINK } from "connectors";
import { DatumizoBase } from "Components/LabIZO/Datumizo/DatumizoProps.interface";
import { observer } from "mobx-react";
import { useState } from "react";

interface IEntityProps {
  title?: string;
  serverSidePagination?: boolean;
  base?: DatumizoBase;
}

const defaultProps: IEntityProps = {
  title: "ENTITIES",
  serverSidePagination: false,
  base: {
    title: "ENTITIES",
    exportDoc: "Entities",
    schema: schema,
    reqAuth: "Workspace.Entity",
    columnAuth: "Entity",

    tablizo: {
      showSelector: true,
      columnsToolbar: true,
      filterToolbar: true,
      densityToolbar: true,
      exportToolbar: false,
    },

    Connect: {
      DBInfo: DATA_LINK.EntityDBInfo,
      List: DATA_LINK.EntityList,
      SetColumnVisibilitySetting: DATA_LINK.EntitySetColumnVisibilitySetting,
      schema: schema.Table,
    },

    operations: {
      Add: {
        title: "Add Entity",
        url: DATA_LINK.EntityAdd,
        success: "Entity Added Successfully",
        fail: "Entity Add Failed: ",
        schema: schema.Add,
        buttons: ["Clear", "Submit"],
        onSubmit: "Add",
      },
      Delete: {
        url: DATA_LINK.EntityDelete,
        success: "Entity Deleted Successfully.",
        fail: "Entity Delete Failed: ",
        onSubmit: "Delete",
        onClick: (id, row, operations) => {
          //chekc if used in context
          let usedInContextAction = row.usedInContextAction;

          if (_.isArray(usedInContextAction) && usedInContextAction.length > 0) {
            const aliasForm = usedInContextAction.map((item) => {
              const [workspace, alias] = item.split(":");
              return alias;
            });
            store.Ask(
              "Warning!",
              `This entity is used in context action: <b>${aliasForm.join(", ")}</b>. <br>Deleting it is prohibited. Please remove it from related context actions first.`,
              (res: any) => {},
              () => {},
              true,
              ["Cancel"]
            );
          } else {
            store.Ask(
              "Delete this Entity?",
              " Caution: This is irrevertable.",
              (res: any) => {
                operations.onSubmit(id, row);
              },
              () => {},
              true,
              ["OK", "Cancel"]
            );
          }
        },
      },
      Edit: {
        title: "Edit Entity ",
        url: DATA_LINK.EntityEdit,
        success: "Entity Edited Successfully",
        fail: "Entity Edit Failed: ",
        schema: schema.Edit,
        buttons: ["Revert", "Submit"],
        onSubmit: "Edit",
      },
      Info: {
        title: "Entity ",
        success: "Entity Load Successfully",
        fail: "Entity Load Failed: ",
        schema: schema.Info,
        readOnly: true,
      },
      Sync: {
        title: "Sync from NLP",
        content: "Caution: This is irrevertable.",
        url: DATA_LINK.EntitySync,
        success: "Entity Sync Successfully.",
        fail: "Entity Sync Failed: ",
        onSubmit: "Sync",
      },
      DeleteBulk: {
        title: (n: string) => "Delete these " + n + " Entities?",
        content: "Caution: This is irrevertable.",
        url: DATA_LINK.EntityDeleteBulk,
        success: "Entities Deleted Successfully.",
        fail: "Entities Delete Failed: ",
        onSubmit: "DeleteBulk",
      },
      Export: {
        url: DATA_LINK.EntityExport,
        exportFileType: "xlsx",
      },
      Import: {
        title: "Entity Import",
        url: DATA_LINK.EntityImport,
        content: "(File size cannot exceed 10MB, only accept .xlsx and .xls)",
        success: "Entity Imported Successfully.",
        fail: "Entity Import Failed: ",
        accept: [".xlsx", ".xls"],
      },
    },

    buttons: {
      inline: [
        { icon: "edit", func: "Edit", caption: "Edit", reqFunc: "Edit" },
        { icon: "info", func: "Info", caption: "Details" },
        { icon: "delete", func: "Delete", caption: "Delete", reqFunc: "Delete" },
      ],
      left: [{ icon: "add", func: "Add", caption: "Add Entity", reqFunc: "Add" }],
      right: [
        { icon: "deletebulk", func: "DeleteBulk", caption: (n) => "Delete (" + n + ")", reqFunc: "Delete", theme: "caution" },
        { icon: "export", func: "Export", caption: (n) => "Export (" + (n === 0 ? "All" : n) + ")", reqFunc: "Export" },
        { icon: "import", func: "Import", caption: "Import", reqFunc: "Import" },
        { icon: "syncfrom", func: "Sync", caption: "Sync", reqFunc: "Sync" },
      ],
    },
  },
};

const Entity: React.FC<IEntityProps> = (props) => {
  const { title, serverSidePagination, base } = props;
  const [MountDatumizo, setMountDatumizo] = useState<any>(false);

  function onMountDatumizo(callback: any) {
    setMountDatumizo(callback);
  }

  async function onQuitInner() {
    await MountDatumizo?.Reload();
  }
  return (
    <VStack>
      <Box padding={1} width="100%">
        <Typography
          style={{
            textAlign: "left",
            width: "100%",
            fontSize: 25,
            color: ColorX.GetColorCSS("Primary"),
          }}
        >
          {title}
        </Typography>
      </Box>
      <Datumizo
        base={base}
        serverSidePagination={serverSidePagination}
        onMounted={onMountDatumizo}
        onQuitInner={onQuitInner}
        addOns={{
          workspace: "master",
        }}
      />
    </VStack>
  );
};

Entity.defaultProps = defaultProps;
export default observer(Entity);
